import {colors} from "@material-ui/core";

import {parseDate} from "../common/Hooks";
import {ActivitySchemaAttributes} from "../attributes/activity-schema-attributes";

export enum SignType {
  in = 1,
  out = 2,
}

export enum WalletType {
  in = 1,
  out = 2,
}

class ActivitySchema {
  id: number;
  tag: string;
  description: string;
  thumbnail?: string | null;
  thumbnail_url?: string | null;
  date: Date;

  sign?: SignType | null;
  amount?: number | null;
  currency?: string | null;
  comment?: string | null;

  constructor(
    id: number,
    tag: string,
    description: string,
    thumbnail: string | null,
    thumbnail_url: string | null,
    date: Date,
    sign: SignType | null,
    amount: number | null,
    currency: string | null,
    comment: string | null
  ) {
    this.id = id;
    this.tag = tag;
    this.description = description;
    this.thumbnail = thumbnail;
    this.thumbnail_url = thumbnail_url;
    this.date = date;
    this.sign = sign;
    this.amount = amount;
    this.currency = currency;
    this.comment = comment;
  }

  static fromJson(json: ActivitySchemaAttributes): ActivitySchema {
    if (json === null || json === undefined) {
      return null;
    }

    return new ActivitySchema(
        json.id,
        json.tag,
        json.description,
        json.thumbnail,
        json.thumbnail_url,
        parseDate(json.date),
        ActivitySchema.computeSign(json.sign),
        json.amount,
        json.currency,
        json.comment,
    );
  }

  static computeSign(sign: string): SignType | null {
    if (sign === "1") {
      return SignType.in;
    }

    if (sign === "2") {
      return SignType.out;
    }

    return null;
  }

  computeSignColor(): string {
    if (this.sign === SignType.in) {
      return colors.green[800];
    }

    if (this.sign === 2) {
      return colors.red[800];
    }

    return "";
  }

  computeSignSymbol(): string {
    if (this.sign === SignType.in) {
      return "+ "
    }

    if (this.sign === 2) {
      return "- "
    }

    return "";
  }

  computeAmount(): string {
    if (this.amount !== null && this.sign === null) {
      return`${this.amount}`;
    }

    if (this.amount !== null && this.sign !== null) {
      return`${this.computeSignSymbol()}  ${this.amount}`;
    }

    return "";
  }
}

export default ActivitySchema;
